<app-user-choice *ngIf="userChoice" [userChoice]="userChoice" (cellClick)="handleCellClick($event)"> </app-user-choice>
